import { BillingPeriod, TimePeriod } from './timePeriod'

export enum COUPON_TYPE {
    FLEXIBLE = 'Flexible',
    FIX = 'Fix',
}
export enum COUPON_DISCOUNT_TYPE {
    REPRICE = 'Reprice',
    AMOUNTOFF = 'AmountOff',
    PERCENTAGEOFF = 'PercentageOff',
}

export enum COUPON_ACTION {
    NEW_PURCHASE = 'NewPurchase',
}

export enum COUPON_PAYMENT_PLAN {
    UPFRONTMONTHLY = 'UpfrontMonthly',
    UPFRONTANNUAL = 'UpfrontAnnual',
    MONTHLYANNUAL = 'MonthlyAnnual',
}

export const BillingPeriodCouponPaymentPlanMapper: Record<BillingPeriod, COUPON_PAYMENT_PLAN> = {
    [BillingPeriod.ANNUAL]: COUPON_PAYMENT_PLAN.UPFRONTANNUAL,
    [BillingPeriod.MONTHLY]: COUPON_PAYMENT_PLAN.UPFRONTMONTHLY,
    [BillingPeriod.ANNUALBILLEDMONTHLY]: COUPON_PAYMENT_PLAN.MONTHLYANNUAL,
}

export const TimePeriodCouponPaymentPlanMapper: Record<TimePeriod, COUPON_PAYMENT_PLAN> = {
    [TimePeriod.Year]: COUPON_PAYMENT_PLAN.UPFRONTANNUAL,
    [TimePeriod.Month]: COUPON_PAYMENT_PLAN.UPFRONTMONTHLY,
    [TimePeriod.AnnualBilledMonthly]: COUPON_PAYMENT_PLAN.MONTHLYANNUAL,
}
